import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';

import { MaintenanceService } from '../../maintenance.service';
import {
  MaintenanceState,
  formatCountdown,
  msUntilStart,
  shouldShowBanner,
} from '../../models/maintenance-state.model';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {

  state: MaintenanceState | null = null;
  visible = false;
  countdown = '';

  private _stateSub: Subscription | null = null;
  private _tickSub: Subscription | null = null;

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit(): void {
    this._stateSub = this.maintenanceService.state$.subscribe((state) => {
      this.state = state;
      this.visible = !!state && shouldShowBanner(state);
      this._updateCountdown();
    });

    this._tickSub = interval(1000).subscribe(() => this._updateCountdown());
  }

  ngOnDestroy(): void {
    this._stateSub?.unsubscribe();
    this._tickSub?.unsubscribe();
  }

  get isWindingDown(): boolean {
    return this.state?.phase === 'winding_down';
  }

  get isScheduled(): boolean {
    return this.state?.phase === 'scheduled';
  }

  get showBanner(): boolean {
    return this.visible;
  }

  private _updateCountdown(): void {
    if (!this.state) return;
    const ms = msUntilStart(this.state);
    this.countdown = formatCountdown(ms);
  }
}
